/**
 * ModalContainer — renders all modals, controlled via store.openModal
 */
import { TemplatesModal } from './modals/TemplatesModal';
import { SettingsModal } from './modals/SettingsModal';
import { ExportModal } from './modals/ExportModal';
import { ColorGeneratorModal } from './modals/ColorGeneratorModal';

export function ModalContainer() {
  return (
    <>
      <TemplatesModal />
      <SettingsModal />
      <ExportModal />
      <ColorGeneratorModal />
    </>
  );
}
